<template>
	<div id="header">
		<div id="logo"><img src="@/assets/images/parts/logo-white.png" /></div>
		<div id="account">
			<div class="accountcircle" @click="toggleAccountInfo">
				<img :src="require('@/assets/images/svg/list.svg')">
			</div>
			<ul v-if="showAccountInfo" class="list-group">
				<li class="list-group-item" @click.prevent="clickUseHistory">利用履歴</li>
				<li class="list-group-item" @click.prevent="clickProfile">ユーザー情報修正</li>
				<li class="list-group-item" @click.prevent="clickPointHistory">ポイント確認</li>
				
				<li class="list-group-item" @click.prevent="clickLogout">ログアウト</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
		},
		data() {
			return {
				showAccountInfo: false
			};
		},
		computed: {
			userName() {
				return this.$store.getters['commonStore/getUserName'];
			},
		},
		methods: {
			toggleAccountInfo() {
				this.showAccountInfo = !this.showAccountInfo;
			},
			clickLogout() {
				this.$dialog.confirm({
					title: '確認',
					body: 'ログアウトしますか？'
				},{
					okText: 'ログアウトする',
					cancelText: 'キャンセル',
					html: true
				})
				.then(async () => {
					this.$store.dispatch('commonStore/logout').then(() => {
						this.$router.push('/login');
					});
				})
				.catch(() => {
				});
			},
			clickProfile() {
				this.$router.push('/profile');
			},
			clickUseHistory() {
				this.$router.push('/usehistory');
			},
			clickPointHistory() {
				this.$router.push('/pointhistory');
			}
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	#header {
		margin: 0 -8px;
		padding: 0;
		box-sizing: border-box;

		#logo {
			padding-left: 48px;
			padding-right: 48px;
			width: 100%;
			height: 40px;
			text-align: center;
			display: flex;
			align-items: center;
			img {
				vertical-align: middle;
				max-height: 40px;
				max-width: 100%;
			}
			background-color: #de0113;
		}
		#account {
			position: absolute;
			right: 4px;
			top: 0;
			.accountcircle {
				cursor: pointer;
				width: 40px;
				height: 40px;
				img {
					width: 100%;
					height: 100%;
					vertical-align: top;
				}
			}
			ul {
				position: absolute;
				right: 0;
				width: 200px;
				text-align: left;
				
				li {
					cursor: pointer;
				}
			}
		}
	}
</style>
